import { render, staticRenderFns } from "./ColorIndicator.vue?vue&type=template&id=7ad488c2"
import script from "./ColorIndicator.vue?vue&type=script&lang=js"
export * from "./ColorIndicator.vue?vue&type=script&lang=js"
import style0 from "./ColorIndicator.vue?vue&type=style&index=0&id=7ad488c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports